<template>
  <div>
    <policy-signature ref="INS_S8"
                      :trans-code="transCode"
                      :change-yn="pChangeYn"
                      :signed-yn="pSignedYn"
                      :is-preview="isPreview"
                      :parent-title="'簽名資料'"
                      @set-change="setChange"
                      @destroy="signatureDestroyHandler"
                      @close="insS8TabCloseHandler"
                      @signed-handler="signedHandler"
                      @next-tab="nextStepHandler"
                      @pre-tab="preStepHandler">
    </policy-signature>
    <base-btn>
      <btn-lg-default @click="preStepHandler">上一步</btn-lg-default>
      <btn-lg-primary v-if="!isPreview" @click="jumpAppClick">跳轉保險公司</btn-lg-primary>
    </base-btn>
    <btn-lg-default style="position: fixed;top: 300px;right: 30px;min-width: 126px;"
            @click="preStepHandler">上一步</btn-lg-default>
    <btn-lg-primary style="position: fixed;top: 360px;right: 30px;min-width: 126px;"
            v-if="!isPreview" @click="jumpAppClick">跳轉保險公司</btn-lg-primary>
  </div>
</template>
<script>
import PolicySignature from '@/components/Ins/Policy/PolicySignature.vue'
import store from '@/store'
import { withDebounce } from '@/utils'
import { createNamespacedHelpers } from 'vuex'
import ProposalStepsBase from './/ProposalStepsBase'
const { mapActions } = createNamespacedHelpers('ins')
export default {
  extends: ProposalStepsBase,
  components: { PolicySignature },
  data () {
    return {
      isFinishedSign: false,
      cusInfoTypeO: {}, //遠距增加，跳轉APP
      policiesInfo: null, //保單資訊
    }
  },
  computed: {
    insAppTime () {  //遠距增加，跳轉APP
      // APP提醒時間(ADM_PARMD-S01)
      let { parameterValue: limit, variableDesc: desc } = this.insParameters['APP_REMIND_TIME']
      limit = parseInt(limit)
      return {limit, desc}
    },
    insHighAgeLimit () {  //遠距增加， 高齡年齡限制(ADM_PARMD-S01)
      let { parameterValue: limit } = this.insParameters['HIGH_AGE_LIMIT']
      limit = parseInt(limit)
      return limit
    },
  },
  beforeRouteEnter (to, from, next) {
    const { transCode} = to.params.propKey
    const reqCusInfo = store.dispatch('ins/fetchCusInfo', { transCode, cusType: ['O'] }) //遠距增加，跳轉APP
    const reqPoliciesInfo = store.dispatch('ins/fetchInsPoliciesInfo', { transCode }) //保單資訊
    Promise.all([reqCusInfo,reqPoliciesInfo]).then(r => {
      const [ rCusInfo,rPoliciesInfo ] = r
       next(vm => {
          vm.cusInfoTypeO = rCusInfo.data.cusList[0]  //遠距增加，跳轉APP
          vm.policiesInfo = rPoliciesInfo.data
       })
    })
  },
  created () {
    console.log('Tab: policy-signature')
  },
  methods: {
    ...mapActions([
      'fetchJumpApp','updatePolState'
    ]),
    doValidate () {
      this.$doValidate('observer').then(isValid => {
        if (!isValid) {
          let num = this.$validateNum('observer')
          this.$emit('set-validate-num', { step: this.tabStep, num })
        } else {
          this.$emit('set-validate-num', { step: this.tabStep, num: 0 })
        }
      })
    },
    preStepHandler: withDebounce(function () {
      this.$emit('set-validate-num', { step: this.tabStep, num: 0 })
      this.$setTabDone(this.tabStep, false)
      this.$postUserAccessLog({ progClassName: 'signature_prev', methodName: '上一步', stepCode: this.tabStep })
      this.$preStepHandler()
    }),
    nextStepHandler () {
      //this.$alert('執行下一步')
      this.$emit('set-validate-num', { step: this.tabStep, num: 8 })
      this.$setTabDone(this.tabStep, true)
      this.$nextStepHandler()
    },
    jumpAppClick: withDebounce(function () {//按鈕點選觸發
      //fix: Issue #83809, Issue #83807 , 調整為 跳轉保險公司
      const {policiesInfo} = this
      if(!policiesInfo) return
      const vm = this
      let msg = []
      msg.push('進入保險公司則不可再異動基本資料，若需異動可退回網頁重新複製調整後再進件，行動投保同意書需以新案號列印給客戶簽署，採遠距投保時，請複製案件重新調整後再進入保險公司')
      msg.push('若繳款人非要/被保險人且為高齡者(65歲以上)，請先完成保險公司高齡錄音取得錄音編號')
      msg.push('若保戶欲投保之商品同時有躉繳及分期繳，採分期繳者請於保險公司商品選擇時留意挑有數字的如 APKSPL02')
      if (this.cusInfoTypeO.insureAge > this.insHighAgeLimit) {
        msg.push('您進件之要保人為高齡，請確認是否已於保險公司完成高齡錄音並記下錄音編號(進入APP時需填寫)')
      }
      if (new Date().getHours() >= this.insAppTime.limit) {
        msg.push('目前已逾' + this.insAppTime.desc + '，因進件保險公司APP僅能同日12小時內完成(不得跨日)，請務必確認今日晚上可完成APP流程及客戶簽名，以避免需隔日重來。')
      }
      let list = []
      let num = 1
      msg.forEach(el => {
        el = '(' + num + ')'  + el
        num++
        list.push(el)
      })
      const actionFlow = () =>{
        //fix: Issue #98267 ，[書面分析資料] 的下一步過來的 [簽名資料] 畫面，若按下 「跳轉保險公司」 則改將 PROG_CLASSNAME 叫 "written_jumpApp"
        vm.insStepHandler({ progClassName: 'written_jumpApp', methodName: '要保書轉跳APP', stepCode: '', transCode: policiesInfo.transCode, polInsureType: policiesInfo.polInsureType})
        if(vm.$refs['INS_S8'] && vm.isFinishedSign){
          vm.$refs['INS_S8'].preViewStepHandler()
        }
        vm.fetchJumpApp({
          transCode: policiesInfo.transCode,
          compCode: policiesInfo.compCode,
          insAcceptDt: policiesInfo.insAcceptDt, // Timestamp 傳去後端轉String處裡
          insAcceptNo: policiesInfo.insAcceptNo
        }).then(r => {
          const { erorrMsg,url } = r.data
          if ( erorrMsg != null) { // 進入時間是否超過12小時或已跨日，顯示錯誤訊息
            vm.$alert(erorrMsg)
          } else {
              vm.updatePolState({ transCode: policiesInfo.transCode, polState: 'O' }).then(rt=>{
              window.open(url, '_blank') // 跳轉凱壽APP
              vm.$router.replace({ name: 'proposal' })
            })
          }
        })
      }
      const actionFunc = () =>{
        this.$confirm('<div style="text-align:left">' + list.join('<br>') + '</div>', yn => {
          if (yn) {
            // 狀態沒有更新為 O + 跳轉保險公司
            actionFlow()
          }
        })
      }
      if(!this.isFinishedSign){
          //fix: Issue #83807 , 『合計應簽名數量』<>『合計已簽名數量』時，額外顯示訊息
          this.$alert('保戶尚未於書面分析及個資同意書簽名，若您為訪客前先協助客戶至保險公司頁面或APP預填，可暫忽略本訊息，但記得正式面訪客戶時務必請客戶於 iPAD先簽「個資同意書及書面分析」２文件，以免投保後需再次回頭請客戶簽署。」').then(actionFunc)
      }else{
          actionFunc()
      }
    }),
    saveHandler () {
      this.$commitAction({ action })
    },
    setChange () {
    },
    signatureDestroyHandler () {
      // this.$emit('destory', true)
      // const $htmlScroll = document.documentElement // 關閉 html scrollbar
      // $htmlScroll.className = ''
      // setTimeout(() => {
      //   window.location.reload()
      // }, 0)
    },
    signedHandler (val) {
      // 客戶全部簽名完成後觸發狀態旗標
      if (val === 'Finished') {
        this.isFinishedSign = true //『合計應簽名數量』=『合計已簽名數量』
      }else{
        this.isFinishedSign = false //『合計應簽名數量』<>『合計已簽名數量』
      }
    },
    insS8TabCloseHandler () {

    },
    insStepHandler ({ progClassName, methodName, stepCode }) {
      // save access log
      store.dispatch('common/postUserAccessLog', {
          transCode: this.transCode,
          actionMsg: '',
          progClassName: progClassName,
          methodName: methodName,
          sysType: 'F',
          stepCode: stepCode
        })
        .then(r => {})
    },
  }

}
</script>
<style lang="stylus" scoped>


</style>
